var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ChatBotAiFaq" } },
    [
      _vm.showCreateFaq
        ? _c("CreateFaq", {
            attrs: { storyId: _vm.storyId },
            on: {
              close: function ($event) {
                _vm.showCreateFaq = false
              },
              "save-faq": _vm.saveFaq,
            },
          })
        : [
            _vm.showingContent
              ? _c("PreviewFaq", {
                  attrs: {
                    "knowledge-base": _vm.showingContent,
                    "story-id": _vm.storyId,
                  },
                  on: {
                    close: function ($event) {
                      _vm.showingContent = null
                    },
                    deleted: function () {
                      return _vm.onDeletedSingle(_vm.showingContent._id)
                    },
                    changed: function (enabled) {
                      return _vm.onChangedStateSingle(
                        _vm.showingContent._id,
                        enabled
                      )
                    },
                    "update-faq": _vm.updateFaq,
                  },
                })
              : !_vm.showingContent
              ? _c("div", { staticClass: "faq-container" }, [
                  _c("div", { staticClass: "header" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("chatbotv2.frequentlyAskedQuestions"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "actions" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            attrs: { primary: "" },
                            on: {
                              click: function ($event) {
                                _vm.showCreateFaq = true
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("add"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.addContent"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("ve-pagination", {
                        attrs: {
                          total: _vm.total,
                          "page-index": _vm.page,
                          "page-size": _vm.pageSize,
                          "page-size-option": [10, 15, 20, 50, 100],
                        },
                        on: {
                          "on-page-number-change": function (val) {
                            return (_vm.page = val)
                          },
                          "on-page-size-change": function (val) {
                            return (_vm.pageSize = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "faq-table" }, [
                      _c(
                        "div",
                        { staticClass: "faq-table-header" },
                        _vm._l(_vm.columns, function (column) {
                          return _c(
                            "div",
                            {
                              key: column.id,
                              staticClass: "faq-table-header-item",
                              style: {
                                flex: column.flex,
                                width: column.width
                                  ? column.width + "px"
                                  : "auto",
                                "max-width": column.maxWidth
                                  ? column.maxWidth + "px"
                                  : "auto",
                              },
                            },
                            [
                              column.isCheckbox
                                ? _c("a-checkbox", {
                                    attrs: { checked: _vm.isSelectAll() },
                                    on: { click: _vm.toggleSelectAll },
                                  })
                                : [_vm._v(_vm._s(column.title))],
                            ],
                            2
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "faq-table-body" },
                        _vm._l(_vm.filteredRows, function (row) {
                          return _c(
                            "div",
                            { key: row._id, staticClass: "row" },
                            _vm._l(_vm.columns, function (column) {
                              return _c(
                                "div",
                                {
                                  key: column.id,
                                  staticClass: "cell",
                                  style: {
                                    flex: column.flex,
                                    width: column.width
                                      ? column.width + "px"
                                      : "auto",
                                    "max-width": column.maxWidth
                                      ? column.maxWidth + "px"
                                      : "auto",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.previewArticles(row)
                                    },
                                  },
                                },
                                [
                                  column.slot === "state"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "d-flex w-100" },
                                          [
                                            row.enabled
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "state-cell active",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbotv2.usedByAi"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "state-cell passive",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "chatbotv2.notUsed"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        column.isCheckbox
                                          ? [
                                              _c("a-checkbox", {
                                                attrs: {
                                                  checked: _vm.isSelected(row),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return function () {
                                                      return _vm.toggleSelect(
                                                        row
                                                      )
                                                    }.apply(null, arguments)
                                                  },
                                                },
                                              }),
                                            ]
                                          : [
                                              column.getData
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        column.getData(row)
                                                      )
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(row[column.id])
                                                    ),
                                                  ]),
                                            ],
                                      ],
                                ],
                                2
                              )
                            }),
                            0
                          )
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.selectedItems.length
                      ? _c("div", { staticClass: "select-panel-wrapper" }, [
                          _c("div", { staticClass: "select-panel" }, [
                            _c("div", { staticClass: "items-count" }, [
                              _vm.busy
                                ? _c(
                                    "i",
                                    { staticClass: "material-icons spin" },
                                    [_vm._v('"autorenew"')]
                                  )
                                : _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("check"),
                                  ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.selectedItems.length) +
                                    " " +
                                    _vm._s(_vm.$t("message.selected"))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "buttons" },
                              [
                                _c(
                                  "SupsisButton",
                                  {
                                    attrs: { small: "", disabled: _vm.busy },
                                    on: {
                                      click: function () {
                                        return _vm.deleteMulti()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("delete"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "SupsisButton",
                                  { attrs: { small: "", disabled: _vm.busy } },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("refresh"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "SupsisButton",
                                  {
                                    attrs: { disabled: _vm.busy },
                                    on: {
                                      click: function () {
                                        return _vm.multiChangeState(false)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("toggle_off"),
                                    ]),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("chatbotv2.disableAi")) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "SupsisButton",
                                  {
                                    attrs: { disabled: _vm.busy },
                                    on: {
                                      click: function () {
                                        return _vm.multiChangeState(true)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("toggle_on"),
                                    ]),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("chatbotv2.enableAi")) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }